var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};

// ../base/src/unit/index.ts
import Decimal from "decimal.js";
Decimal.set({ precision: 80 });
var calcDecimals = (decimals = 18) => {
  let _decimals = decimals;
  if (typeof decimals !== "number" || decimals <= 0) {
    _decimals = 18;
  }
  return Decimal.pow(10, _decimals);
};
var isBigint = (value) => typeof value === "bigint";
var _Unit = class {
  value;
  constructor(value) {
    if (_Unit.isUnit(value)) {
      this.value = value.value;
    } else if (Decimal.isDecimal(value)) {
      this.value = value;
    } else {
      this.value = new Decimal(isBigint(value) ? value.toString() : value);
    }
  }
  equals = (another) => {
    const _another = new _Unit(another);
    return this.value.eq(_another.value);
  };
  lessThan = (another) => {
    const _another = new _Unit(another);
    return this.value.lessThan(_another.value);
  };
  greaterThan = (another) => {
    const _another = new _Unit(another);
    return this.value.greaterThan(_another.value);
  };
  lessThanOrEqualTo = (another) => {
    const _another = new _Unit(another);
    return this.value.lessThanOrEqualTo(_another.value);
  };
  greaterThanOrEqualTo = (another) => {
    const _another = new _Unit(another);
    return this.value.greaterThanOrEqualTo(_another.value);
  };
  add = (another) => {
    const _another = new _Unit(another);
    return new _Unit(this.value.add(_another.value));
  };
  sub = (another) => {
    const _another = new _Unit(another);
    return new _Unit(this.value.sub(_another.value));
  };
  mul = (another) => {
    const _another = new _Unit(another);
    return new _Unit(this.value.mul(_another.value));
  };
  div = (another) => {
    const _another = new _Unit(another);
    return new _Unit(this.value.div(_another.value));
  };
  pow = (another) => {
    const _another = new _Unit(another);
    return new _Unit(this.value.pow(_another.value));
  };
  log = (another) => {
    const _another = new _Unit(another);
    return new _Unit(this.value.log(_another.value));
  };
  sqrt = () => {
    return new _Unit(this.value.sqrt());
  };
  mod = (another) => {
    const _another = new _Unit(another);
    return new _Unit(this.value.mod(_another.value));
  };
  equalsWith = (another) => {
    const _another = new _Unit(another);
    return this.value.eq(_another.value);
  };
  isNaN = () => {
    return this.value.isNaN();
  };
  isFinite = () => {
    return this.value.isFinite();
  };
  toDecimalStandardUnit = (toFixed, decimals = 18) => {
    if (typeof toFixed === "number" && toFixed >= 0) {
      const strVal = this.value.div(calcDecimals(decimals)).toFixed();
      if (strVal === "NaN")
        return strVal;
      if (strVal.indexOf("Infinity") !== -1)
        return strVal;
      if (strVal.indexOf("e") !== -1)
        return strVal;
      const dotIndex = strVal.indexOf(".");
      if (toFixed === 0)
        return strVal.slice(0, dotIndex);
      if (dotIndex === -1)
        return strVal + "." + "0".repeat(toFixed);
      if (strVal.length - dotIndex - 1 < toFixed)
        return strVal + "0".repeat(toFixed - (strVal.length - dotIndex - 1));
      return strVal.slice(0, dotIndex) + "." + strVal.slice(dotIndex + 1, dotIndex + toFixed + 1);
    }
    return this.value.div(calcDecimals(decimals)).toFixed();
  };
  toHexStandardUnit = (decimals = 18) => {
    return this.value.div(calcDecimals(decimals)).toHex();
  };
  toDecimalMinUnit = (toFixed) => {
    if (typeof toFixed === "number" && toFixed >= 0) {
      const strVal = this.value.toFixed();
      if (strVal === "NaN")
        return strVal;
      if (strVal.indexOf("Infinity") !== -1)
        return strVal;
      if (strVal.indexOf("e") !== -1)
        return strVal;
      const dotIndex = strVal.indexOf(".");
      if (toFixed === 0)
        return dotIndex === -1 ? strVal : strVal.slice(0, dotIndex);
      if (dotIndex === -1)
        return strVal + "." + "0".repeat(toFixed);
      if (strVal.length - dotIndex - 1 < toFixed)
        return strVal + "0".repeat(toFixed - (strVal.length - dotIndex - 1));
      return strVal.slice(0, dotIndex) + "." + strVal.slice(dotIndex + 1, dotIndex + toFixed + 1);
    }
    return this.value.toFixed();
  };
  toHexMinUnit = () => {
    return this.value.toHex();
  };
  toString = () => {
    return this.toDecimalStandardUnit();
  };
  toDecimal = () => {
    return this.value;
  };
  [Symbol.toPrimitive](hint) {
    return hint == "string" ? this.toDecimalStandardUnit() : this.value;
  }
};
var Unit = _Unit;
__publicField(Unit, "isUnit", (obj) => obj instanceof _Unit);
__publicField(Unit, "fromStandardUnit", (value, decimals = 18) => {
  if (Decimal.isDecimal(value) || _Unit.isUnit(value)) {
    return new _Unit(value.mul(calcDecimals(decimals)));
  }
  return new _Unit(new Decimal(isBigint(value) ? value.toString() : value).mul(calcDecimals(decimals)));
});
__publicField(Unit, "fromMinUnit", (value) => {
  if (Decimal.isDecimal(value) || _Unit.isUnit(value)) {
    return new _Unit(value);
  }
  return new _Unit(new Decimal(isBigint(value) ? value.toString() : value));
});
__publicField(Unit, "fromDecimal", (value) => {
  return _Unit.fromMinUnit(value);
});
__publicField(Unit, "equals", (a, b) => {
  const _a = new _Unit(a);
  const _b = new _Unit(b);
  return _a.value.eq(_b.value);
});
__publicField(Unit, "min", (a, b) => {
  const _a = new _Unit(a);
  const _b = new _Unit(b);
  return _a.greaterThan(_b) ? _b : _a;
});
__publicField(Unit, "max", (a, b) => {
  const _a = new _Unit(a);
  const _b = new _Unit(b);
  return _a.greaterThan(_b) ? _a : _b;
});
__publicField(Unit, "clamp", (value, min, max) => {
  const _value = new _Unit(value);
  const _min = new _Unit(min);
  const _max = new _Unit(max);
  return _value.greaterThan(_max) ? _max : _value.lessThan(_min) ? _min : _value;
});
__publicField(Unit, "lessThan", (a, b) => {
  const _a = new _Unit(a);
  const _b = new _Unit(b);
  return _a.value.lessThan(_b.value);
});
__publicField(Unit, "greaterThan", (a, b) => {
  const _a = new _Unit(a);
  const _b = new _Unit(b);
  return _a.value.greaterThan(_b.value);
});
__publicField(Unit, "lessThanOrEqualTo", (a, b) => {
  const _a = new _Unit(a);
  const _b = new _Unit(b);
  return _a.value.lessThanOrEqualTo(_b.value);
});
__publicField(Unit, "greaterThanOrEqualTo", (a, b) => {
  const _a = new _Unit(a);
  const _b = new _Unit(b);
  return _a.value.greaterThanOrEqualTo(_b.value);
});
__publicField(Unit, "add", (a, b) => {
  const _a = new _Unit(a);
  const _b = new _Unit(b);
  return new _Unit(_a.value.add(_b.value));
});
__publicField(Unit, "sub", (a, b) => {
  const _a = new _Unit(a);
  const _b = new _Unit(b);
  return new _Unit(_a.value.sub(_b.value));
});
__publicField(Unit, "mul", (a, b) => {
  const _a = new _Unit(a);
  const _b = new _Unit(b);
  return new _Unit(_a.value.mul(_b.value));
});
__publicField(Unit, "div", (a, b) => {
  const _a = new _Unit(a);
  const _b = new _Unit(b);
  return new _Unit(_a.value.div(_b.value));
});
__publicField(Unit, "pow", (a, b) => {
  const _a = new _Unit(a);
  const _b = new _Unit(b);
  return new _Unit(_a.value.pow(_b.value));
});
__publicField(Unit, "log", (a, b) => {
  const _a = new _Unit(a);
  const _b = new _Unit(b);
  return new _Unit(_a.value.log(_b.value));
});
__publicField(Unit, "sqrt", (target) => {
  const _target = new _Unit(target);
  return new _Unit(_target.value.sqrt());
});
__publicField(Unit, "mod", (a, b) => {
  const _a = new _Unit(a);
  const _b = new _Unit(b);
  return new _Unit(_a.value.mod(_b.value));
});
__publicField(Unit, "isNaN", (target) => {
  if (typeof target !== "object") {
    return Number.isNaN(Number(target));
  }
  if (Decimal.isDecimal(target))
    return target.isNaN();
  if (_Unit.isUnit(target))
    return target.isNaN();
  return false;
});
__publicField(Unit, "isFinite", (target) => {
  if (typeof target !== "object") {
    return Number.isFinite(Number(target));
  }
  if (Decimal.isDecimal(target))
    return target.isFinite();
  if (_Unit.isUnit(target))
    return target.isFinite();
  return false;
});
var unit_default = Unit;
export {
  unit_default as default
};
